import { Account } from "query/graphql"
import { ChainId } from "web3/constants/chains"

// TODO(@nicolas): This type is duplicated in different files
type RewardRecipient = Pick<Account, "address" | "picture" | "name"> & {
  rewardValue: string
  isTally?: boolean
}

export const getTallyRewardRecipient = (
  chainId: string,
): RewardRecipient | undefined => {

  if (chainId === ChainId.EthereumMainnet) {
    const tallyRecipient: RewardRecipient = {
      address: "0x22A34B3b005d6b59354aEc77d3F7E25e01475fc4",
      picture:
        "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
      name: "Tally",
      rewardValue: "0",
    }

    return tallyRecipient
  }

  if (chainId === ChainId.PolygonMainnet) {
    const tallyRecipient: RewardRecipient = {
      address: "0x22A34B3b005d6b59354aEc77d3F7E25e01475fc4",
      picture:
        "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
      name: "Tally",
      rewardValue: "0",
    }

    return tallyRecipient
  }

  if (chainId === ChainId.Gnosis) {
    const tallyRecipient: RewardRecipient = {
      address: "0x22A34B3b005d6b59354aEc77d3F7E25e01475fc4",
      picture:
        "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
      name: "Tally",
      rewardValue: "0",
    }

    return tallyRecipient
  }

  if (chainId === ChainId.BnbSmartChainMainnet) {
    const tallyRecipient: RewardRecipient = {
      address: "0x22A34B3b005d6b59354aEc77d3F7E25e01475fc4",
      picture:
        "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
      name: "Tally",
      rewardValue: "0",
    }

    return tallyRecipient
  }

  if (chainId === ChainId.Scroll) {
    const tallyRecipient: RewardRecipient = {
      address: "0x22A34B3b005d6b59354aEc77d3F7E25e01475fc4",
      picture:
        "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
      name: "Tally",
      rewardValue: "0",
    }

    return tallyRecipient
  }

  if (chainId === ChainId.CeloMainnet) {
    const tallyRecipient: RewardRecipient = {
      address: "0x920A531871F524f49C4346b2528260FF152D3c4E",
      picture:
        "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
      name: "Tally",
      rewardValue: "0",
    }

    return tallyRecipient
  }

  if (chainId === ChainId.ZKsyncEraMainnet) {
    const tallyRecipient: RewardRecipient = {
      address: "0x8CB21e8013941DE49A646f65673adcf543fF970c",
      picture:
        "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
      name: "Tally",
      rewardValue: "0",
    }

    return tallyRecipient
  }

  if (chainId === ChainId.AvalancheCChain) {
    const tallyRecipient: RewardRecipient = {
      address: "0x22A34B3b005d6b59354aEc77d3F7E25e01475fc4",
      picture:
        "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
      name: "Tally",
      rewardValue: "0",
    }

    return tallyRecipient
  }

  if (chainId === ChainId.Optimism) {
    const tallyRecipient: RewardRecipient = {
      address: "0x22A34B3b005d6b59354aEc77d3F7E25e01475fc4",
      picture:
        "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
      name: "Tally",
      rewardValue: "0",
    }

    return tallyRecipient
  }

  if (chainId === ChainId.ArbitrumOne) {
    const tallyRecipient: RewardRecipient = {
      address: "0x22A34B3b005d6b59354aEc77d3F7E25e01475fc4",
      picture:
        "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
      name: "Tally",
      rewardValue: "0",
    }

    return tallyRecipient
  }

  if (chainId === ChainId.Base) {
    const tallyRecipient: RewardRecipient = {
      address: "0x22A34B3b005d6b59354aEc77d3F7E25e01475fc4",
      picture:
        "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
      name: "Tally",
      rewardValue: "0",
    }
    return tallyRecipient
  }

  if (chainId === ChainId.EthereumTestnetSepolia) {
    const tallyRecipient: RewardRecipient = {
      address: "0x920A531871F524f49C4346b2528260FF152D3c4E",
      picture:
        "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
      name: "Tally",
      rewardValue: "0",
    }
    return tallyRecipient
  }

  const tallyRecipient: RewardRecipient = {
    address: "0x920A531871F524f49C4346b2528260FF152D3c4E",
    picture:
      "https://static.tally.xyz/6adf2df8-68b3-4ccd-81bb-989c28dd6a81_400x400.jpg",
    name: "Tally",
    rewardValue: "0",
  }
  return tallyRecipient
}

export const TALLY_FEE = 0.0025 // 0.25% of transfers

